import { useSelector } from 'react-redux';
import { UserState } from '@/redux/auth/auth';
import gradientBg from '@/assets/gradient-bg.png';

function PostCommentFormHeader() {
  const { isAuthenticated, user } = useSelector(
    (state: { auth: UserState }) => state.auth
  );

  // Signed-in users don't need to be told who they are — the composer is theirs.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (user && isAuthenticated) return <></>;

  return (
    <div
      className="h-[72px] w-full bg-cover bg-center flex items-center justify-center overflow-hidden rounded-md"
      style={{ backgroundImage: `url(${gradientBg})` }}
    >
      <h1 className="font-primary font-medium text-xl leading-[26px] text-[#FFFFFF]">
        Whoops! You’re Missing out..
      </h1>
    </div>
  );
}

export default PostCommentFormHeader;
